import React from "react";
import Favicon from "react-favicon";
import { CLOVIS_FAVICON_URL } from "~/config/user/user-notifications/notifications-favicon/index";

function BaseFavicon() {
  return <Favicon url={CLOVIS_FAVICON_URL} />;
}

export { BaseFavicon };
